import { keyframes } from '@angular/animations';
import {
  Component,
  ComponentFactoryResolver,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { SmartButtonUiComponent } from '@iupics-components/standard/fields/smart-button-ui/smart-button-ui.component';
import { UICreatorService } from '@iupics-manager/managers/ui-creator/ui-creator.service';
import { IupicsTypeEvent } from '@iupics-manager/models/iupics-event';

@Component({
  selector: 'iu-menu-smartbuttons-ui',
  templateUrl: './menu-smartbuttons-ui.component.html',
  styleUrls: ['./menu-smartbuttons-ui.component.scss']
})
export class MenuSmartbuttonsUiComponent implements OnInit {
  targetsWindow = [];
  widthAvailable: number;
  isMoreButton = true;
  smartButtons: any[];
  defaultWidthAvailable: number;

  @ViewChild('smartButtonsVCR', { read: ViewContainerRef, static: true })
  smartButtonsVCR: ViewContainerRef;

  @ViewChild('smartButtonsMoreVCR', { read: ViewContainerRef, static: true })
  smartButtonsMoreVCR: ViewContainerRef;

  @Output()
  smartButtonClick: EventEmitter<any> = new EventEmitter();
  subscription: any;
  constructor(private ref: ElementRef, private resolver: ComponentFactoryResolver, private uiCreator: UICreatorService) {}

  ngOnInit() {
    this.isMoreButton = false;
  }

  refreshSmartButtons(tabId: number, recordId: string) {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.uiCreator
      .getZoomTarget(tabId, recordId.split(',')[0], parseFloat(recordId.split(',')[1]))
      .subscribe((smartButtons: any[]) => {
        this.smartButtonsVCR.clear();
        if (this.smartButtonsMoreVCR) {
          this.smartButtonsMoreVCR.clear();
        }
        this.isMoreButton = false;
        this.defaultWidthAvailable = this.ref.nativeElement.clientWidth;
        this.widthAvailable = this.defaultWidthAvailable;
        this.smartButtons = smartButtons;
        smartButtons.forEach((smartButton: any) => {
          this.addSmartButtonToView(smartButton);
        });
        this.subscription.unsubscribe();
      });
  }

  addSmartButtonToView(smartButton: any) {
    const componentFactory = this.resolver.resolveComponentFactory(SmartButtonUiComponent);
    const componentRef = this.smartButtonsVCR.createComponent(componentFactory);
    (<SmartButtonUiComponent>componentRef.instance).label = smartButton.name;
    (<SmartButtonUiComponent>componentRef.instance).key = smartButton.key;
    (<SmartButtonUiComponent>componentRef.instance).id = smartButton.id;
    (<SmartButtonUiComponent>componentRef.instance).iconClass = smartButton.icon;
    (<SmartButtonUiComponent>componentRef.instance).smartButtonClick.subscribe(val => {
      this.smartButtonClick.emit({ key: keyframes, val: val });
    });
    if (this.widthAvailable - (<SmartButtonUiComponent>componentRef.instance).buttonWidth > 0) {
      this.widthAvailable = this.widthAvailable - (<SmartButtonUiComponent>componentRef.instance).buttonWidth;
    } else {
      this.smartButtonsVCR.detach(this.smartButtonsVCR.indexOf(componentRef.hostView));
      this.smartButtonsMoreVCR.insert(componentRef.hostView);
      this.widthAvailable = 0;
      this.isMoreButton = true;
    }
  }

  resizeSmartButton(type: IupicsTypeEvent) {
    if (type === IupicsTypeEvent.collapseEvent && this.smartButtons) {
      this.widthAvailable = 549;
      this.smartButtonsVCR.clear();
      if (this.smartButtonsMoreVCR) {
        this.smartButtonsMoreVCR.clear();
      }
      this.isMoreButton = false;
      this.smartButtons.forEach((smartButton: any) => {
        this.addSmartButtonToView(smartButton);
      });
    } else if (type === IupicsTypeEvent.expandEvent && this.smartButtons) {
      this.widthAvailable = this.defaultWidthAvailable;
      this.smartButtonsVCR.clear();
      if (this.smartButtonsMoreVCR) {
        this.smartButtonsMoreVCR.clear();
      }
      this.isMoreButton = false;
      this.smartButtons.forEach((smartButton: any) => {
        this.addSmartButtonToView(smartButton);
      });
    }
  }
}
